import styled from 'styled-components'

export const StyledWrapper = styled.section`
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const StyledText = styled.span`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
`
